import { Mail, MapPin, Globe } from 'lucide-react';
import { SEO } from '../components/SEO';

export default function ContactPage() {
  return (
    <div data-testid="contact-page">
      <SEO
        title="Contact Us"
        description="Get in touch with MarketsReview.org for editorial inquiries, partnership proposals, or corrections regarding our broker reviews."
        canonical="/contact"
      />
      <section className="bg-slate-900 text-white py-14">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight font-['Outfit'] mb-4">Contact Us</h1>
          <p className="text-base text-slate-300 max-w-2xl">
            Have questions about our reviews or want to get in touch? Reach out using the information below.
          </p>
        </div>
      </section>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
          {[
            { icon: Mail, title: 'Email', value: 'info@vipaffiliatenetwork.com', href: 'mailto:info@vipaffiliatenetwork.com' },
            { icon: Globe, title: 'Website', value: 'marketsreview.org', href: 'https://marketsreview.org' },
            { icon: MapPin, title: 'Location', value: 'Online Publication', href: null },
          ].map(item => (
            <div key={item.title} className="bg-white border border-slate-200 rounded-xl p-6 text-center">
              <item.icon className="w-8 h-8 text-blue-600 mx-auto mb-3" />
              <h3 className="text-sm font-semibold text-slate-900 mb-1">{item.title}</h3>
              {item.href ? (
                <a href={item.href} className="text-sm text-blue-600 hover:text-blue-700 transition-colors">{item.value}</a>
              ) : (
                <span className="text-sm text-slate-600">{item.value}</span>
              )}
            </div>
          ))}
        </div>

        <div className="bg-white border border-slate-200 rounded-xl p-8">
          <h2 className="text-xl font-semibold text-slate-900 font-['Outfit'] mb-4">Send a Message</h2>
          <p className="text-sm text-slate-600 mb-6">
            For editorial inquiries, partnership proposals, or corrections regarding our broker reviews, please email us directly.
          </p>
          <form
            onSubmit={(e) => { e.preventDefault(); alert('Thank you for your message. We will respond shortly.'); }}
            className="space-y-4"
            data-testid="contact-form"
          >
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-1.5">Name</label>
                <input
                  type="text"
                  required
                  className="w-full rounded-md border border-slate-200 px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent"
                  placeholder="Your name"
                  data-testid="contact-name-input"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-1.5">Email</label>
                <input
                  type="email"
                  required
                  className="w-full rounded-md border border-slate-200 px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent"
                  placeholder="you@email.com"
                  data-testid="contact-email-input"
                />
              </div>
            </div>
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1.5">Subject</label>
              <input
                type="text"
                required
                className="w-full rounded-md border border-slate-200 px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent"
                placeholder="What is this about?"
                data-testid="contact-subject-input"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1.5">Message</label>
              <textarea
                required
                rows={5}
                className="w-full rounded-md border border-slate-200 px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent resize-none"
                placeholder="Your message..."
                data-testid="contact-message-input"
              />
            </div>
            <button
              type="submit"
              className="inline-flex items-center justify-center rounded-md text-sm font-medium bg-slate-900 text-white hover:bg-slate-800 h-10 px-6 transition-colors"
              data-testid="contact-submit-btn"
            >
              Send Message
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
